var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSelectIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1715_17113)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1715_17113",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 33,
    height: 33
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.333496 0.333376H32.3335V32.3334H0.333496V0.333376Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1715_17113)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3335 16.3334V10.7084C16.3335 9.67287 17.173 8.83337 18.2085 8.83337C19.244 8.83337 20.0835 9.67287 20.0835 10.7084V16.3334",
    stroke: "#344054",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0835 16.3334V12.5834C20.0835 11.5479 20.923 10.7084 21.9585 10.7084C22.994 10.7084 23.8335 11.5479 23.8335 12.5834V16.3334",
    stroke: "#344054",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8335 14.4584C23.8335 13.4229 24.673 12.5834 25.7085 12.5834C26.744 12.5834 27.5835 13.4229 27.5835 14.4584V23.5406C27.5835 27.3822 24.8208 30.8581 21.0062 31.3132C20.6347 31.3575 20.2893 31.3975 19.9636 31.3958C14.4585 31.3684 12.5835 27.5834 5.63282 19.5341C4.90039 18.8016 4.90039 17.6151 5.63282 16.8827C6.36526 16.1503 7.55176 16.1503 8.2842 16.8827L12.5836 21.1821L12.5835 3.14589C12.5835 2.11039 13.423 1.27089 14.4585 1.27089C15.494 1.27089 16.3335 2.11039 16.3335 3.14589V14.4584",
    stroke: "#344054",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1715_17113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.333496 0.333374)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectIcon);
export default __webpack_public_path__ + "static/media/SelectIcon.68556743cc9e1f9aac5d9eeee5a321fc.svg";
export { ForwardRef as ReactComponent };